import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { modulesService } from '@/services';
import { Providers, State } from './types';
import {
  SET_ID,
  SET_MAIN,
  FETCH_ITEM,
  SET_FOOTER,
  SET_SIDEBAR,
  SET_NOTHING_FOUND,
  SET_PROFESSION_ID,
} from './consts';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class ModulesListStore extends VuexModule<State, any> {
    id = '';
    main = null;
    footer = null;
    sidebar = null;
    professionId = '';
    nothingFound = false;

    @Mutation
    [SET_SIDEBAR](sidebar: any) {
      this.sidebar = Object.freeze(sidebar);
    }

    @Mutation
    [SET_MAIN](main: any) {
      this.main = Object.freeze(main);
    }

    @Mutation
    [SET_FOOTER](footer: any) {
      this.footer = Object.freeze(footer);
    }

    @Mutation
    [SET_ID](id: string) {
      this.id = id;
    }

    @Mutation
    [SET_PROFESSION_ID](professionId: string) {
      this.professionId = professionId;
    }

    @Mutation
    [SET_NOTHING_FOUND](payload: boolean) {
      this.nothingFound = payload;
    }

    @Action
    async [FETCH_ITEM](params: any) {
      const { commit } = this.context;

      try {
        const { data } = await modulesService($api).getModule(params);

        commit(SET_ID, data.id);
        commit(SET_MAIN, data.main);
        commit(SET_FOOTER, data.footer);
        commit(SET_SIDEBAR, data.sidebar);
        commit(SET_PROFESSION_ID, data.professionId);
      } catch (err) {
        const error: any = err;
        if (error.response && error.response.status === 404) {
          commit(SET_NOTHING_FOUND, true);
        }
      }
    }
  }

  return ModulesListStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/modules/card/store.ts